<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" :title="$t('addAccident.title')" backdrop shadow
            :visible="allowAddAccident" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('safetyShared.basic') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addAccident.recordLabel')" class="text-left mb-0" v-if="showRecordField">
                            <b-form-input v-model="accidentPayload.record_no" type="text" :placeholder="$t('addAccident.recordPlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.record_no" class="field-error">
                                {{ errors.record_no[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('addAccident.recordLabel')" class="text-left mb-0" v-else>
                            <b-form-input v-model="lastRecord" disabled type="text" :placeholder="$t('addAccident.recordPlaceholder')" class="unit"
                                required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.statusLabel') }}</label>
                            <b-form-select v-model="accidentPayload.status" class="f-12" :options="statusOptions" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label for="accident-add-datepicker" class="state">{{ $t('addAccident.dateLabel') }}</label>
                        <date-picker v-model="accidentPayload.date" :formatter="momentFormat" :range-separator="' - '"
                            @clear="accidentPayload.date = ''" :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom"
                            :teleport="'body'"></date-picker>
                        <p v-if="errors && errors.date" class="field-error">
                            {{ errors.date[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="mt-3 text-left">
                        <label class="state">{{ $t('addAccident.timeLabel') }}</label>
                        <b-form-input type="time" class="f-12" v-model="accidentPayload.time"></b-form-input>
                    </b-col>
                    <b-col sm="12">                                    
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.driverLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="accidentPayload.driver" :options="driverOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchDriver">
                                <span slot="no-options">
                                    {{ $t('addAccident.searchDriver') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.driver" class="field-error">
                                {{ errors.driver[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.vehicleLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="accidentPayload.vehicle"
                                :options="vehicleOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                                @search="searchVehicle">
                                <span slot="no-options">
                                    {{ $t('addAccident.searchVehicle') }}
                                </span>
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.trailerLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="accidentPayload.trailer"
                                :options="trailerOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                                @search="searchTrailer">
                                <span slot="no-options">
                                    {{ $t('addAccident.searchTrailer') }}
                                </span>
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.divisionLabel') }}</label>
                            <v-select class="f-12" :clearable="false" :options="allDivisions"
                                v-model="accidentPayload.division" :reduce="(option) => option.id" />
                        </div>
                    </b-col>
                    <b-col sm="12">
                         <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.dotLabel') }}</label>
                            <b-form-select v-model="accidentPayload.dot_status" class="f-12" :options="boolFilterOptions" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addAccident.faultLabel') }}</label>
                            <b-form-select v-model="accidentPayload.fault_status" class="f-12" :options="boolFilterOptions" />
                        </div>
                    </b-col>
                    <b-col md="12" class="text-left mt-3">
                        <label class="state text-left">{{ $t('addAccident.notesLabel') }}</label>
                        <b-form-textarea id="textarea" :placeholder="$t('addAccident.notesPlaceholder')" rows="5" v-model="accidentPayload.notes"
                            class="f-12"></b-form-textarea>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.claimsSection') }}</h3>
                    <b-col md="12" sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.claimsLabel') }}</label>
                        <v-select class="bg_white w-100 f-12" multiple v-model="claimNumbers" :options="claimOptions"
                            item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchClaims">
                            <span slot="no-options">
                                {{ $t('addAccident.searchClaim') }}
                            </span>
                        </v-select>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.locationSection') }}</h3>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.addressLabel') }}</label>
                        <b-form-input v-model="accidentPayload.address" class="f-12"
                            :placeholder="$t('addAccident.addressPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.cityLabel') }}</label>
                        <b-form-input v-model="accidentPayload.city" class="f-12" :placeholder="$t('addAccident.cityPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12">
                        <div class="text-left select_arrow mt-3">
                            <label class="state">{{ $t('addAccident.stateLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="accidentPayload.state" :options="states"
                                item-value="id" item-text="label" :reduce="(option) => option.id">
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.postalCodeLabel') }}</label>
                        <b-form-input v-model="accidentPayload.postal_code" class="f-12"
                            :placeholder="$t('addAccident.postalCodePlaceholder')"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="px-4 my-3 position-relative">
                    <svg v-if="accidentPayload.drawing_data" class="accident-img-edit"
                        @click="$bvModal.show('modal-drawing-accident')" width="30" height="30" viewBox="0 0 30 30"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="30" height="30" rx="8" fill="#F5F5F5" />
                        <path
                            d="M12.4801 21.575L19.7753 14.2798L16.3102 10.8147L9.01503 18.1099C8.9146 18.2105 8.84325 18.3363 8.80857 18.4742L8 22.59L12.1151 21.7814C12.2532 21.7469 12.3796 21.6755 12.4801 21.575ZM22.1303 11.9248C22.4247 11.6303 22.59 11.2311 22.59 10.8147C22.59 10.3984 22.4247 9.99915 22.1303 9.70472L20.8853 8.45969C20.5909 8.16535 20.1916 8 19.7753 8C19.3589 8 18.9597 8.16535 18.6652 8.45969L17.4202 9.70472L20.8853 13.1698L22.1303 11.9248Z"
                            fill="#2CCE89" />
                    </svg>

                    <div class="drawing-section">
                        <img :src="accidentPayload.drawing_data.image" v-if="accidentPayload.drawing_data"
                            class="w-100 h-100" />
                    </div>
                    <div class="ml-auto pr-3">
                        <b-button class="mx-0 h-40px mt-3" variant="primary"
                            @click="$bvModal.show('modal-drawing-accident')" v-if="!accidentPayload.drawing_data">{{ $t('addAccident.drawAccident') }}</b-button>
                    </div>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.detailsSection') }}</h3>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.numVehiclesLabel') }}</label>
                        <b-form-input v-model="accidentPayload.number_of_vehicles" class="f-12"
                            :placeholder="$t('addAccident.numVehiclesPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.hazmatLabel') }}</label>
                        <b-form-select v-model="accidentPayload.hazmat_or_gas_spill" class="f-12" :options="hazmatOptions" />
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.surfaceLabel') }}</label>
                        <b-form-select v-model="accidentPayload.surface" class="f-12" :options="surfaceOptions" />
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.weatherLabel') }}</label>
                        <b-form-select v-model="accidentPayload.weather" class="f-12" :options="weatherOptions" />
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.numInjuryLabel') }}</label>
                        <b-form-input v-model="accidentPayload.number_of_injury" class="f-12"
                            :placeholder="$t('addAccident.numInjuryPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addAccident.numFatalityLabel') }}</label>
                        <b-form-input v-model="accidentPayload.number_of_fatality" class="f-12"
                            :placeholder="$t('addAccident.numFatalityPlaceholder')"></b-form-input>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.officerSection') }}</h3>
                    <b-col sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left">
                                <label>{{ $t('addAccident.yesLabel') }}</label>
                                <b-form-checkbox name="check-button" class="ml-0-6rem"
                                    v-model="accidentPayload.officer_on_site" switch size="lg"></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" v-if="accidentPayload.officer_on_site">
                        <b-row>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.reportLabel') }}</label>
                                <b-form-input v-model="accidentPayload.report_number" class="f-12"
                                    :placeholder="$t('addAccident.reportPlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12">
                                <div class="text-left select_arrow mt-3">
                                    <label class="state">{{ $t('addAccident.stateLabel') }}</label>
                                    <v-select class="bg_white w-100 f-12" v-model="accidentPayload.report_state"
                                        :options="states" item-value="id" item-text="label" :reduce="(option) => option.id">
                                    </v-select>
                                </div>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.citationIssuedLabel') }}</label>
                                <b-form-select v-model="accidentPayload.citation_issues" class="f-12" :options="citationIssuesOptions" />
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.citationNumberLabel') }}</label>
                                <b-form-input v-model="accidentPayload.citation_number" class="f-12"
                                    :placeholder="$t('addAccident.citationNumberPlaceholder')"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.ambulanceSection') }}</h3>
                    <b-col sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left">
                                <label>{{ $t('addAccident.yesLabel') }}</label>
                                <b-form-checkbox name="check-button" class="ml-0-6rem"
                                    v-model="accidentPayload.ambulance_on_site" switch size="lg"></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" v-if="accidentPayload.ambulance_on_site">
                        <b-row>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.nameLabel') }}</label>
                                <b-form-input v-model="accidentPayload.ambulance_name" class="f-12"
                                    :placeholder="$t('addAccident.namePlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.locationLabel') }}</label>
                                <b-form-input v-model="accidentPayload.ambulance_location" class="f-12"
                                    :placeholder="$t('addAccident.locationPlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.driverTreatedLabel') }}</label>
                                <b-form-select v-model="accidentPayload.driver_treated_by_ambulance" class="f-12" :options="yesNoNullOptions" />
                            </b-col>
                            <b-col sm="12" class="text-left mt-3"
                                v-if="accidentPayload.driver_treated_by_ambulance === true">
                                <label class="state">{{ $t('addAccident.wasFatalityLabel') }}</label>
                                <b-form-select v-model="accidentPayload.is_fatality" class="f-12" :options="yesNoNullOptions" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.towingSection') }}</h3>
                    <b-col sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left">
                                <label>{{ $t('addAccident.yesLabel') }}</label>
                                <b-form-checkbox name="check-button" class="ml-0-6rem" v-model="accidentPayload.towing"
                                    switch size="lg"></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" v-if="accidentPayload.towing">
                        <b-row>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.nameLabel') }}</label>
                                <b-form-input v-model="accidentPayload.towing_name" class="f-12"
                                    :placeholder="$t('addAccident.namePlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.locationLabel') }}</label>
                                <b-form-input v-model="accidentPayload.towing_location" class="f-12"
                                    :placeholder="$t('addAccident.locationPlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.vehicleTowedLabel') }}</label>
                                <b-form-select v-model="accidentPayload.vehicle_towed" class="f-12" :options="yesNoNullOptions" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.loadedTrailerSection') }}</h3>
                    <b-col sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left">
                                <label>{{ $t('addAccident.yesLabel') }}</label>
                                <b-form-checkbox name="check-button" class="ml-0-6rem"
                                    v-model="accidentPayload.loaded_trailer" switch size="lg"></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" v-if="accidentPayload.loaded_trailer">
                        <b-row>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.customerLabel') }}</label>
                                <b-form-input v-model="accidentPayload.customer" class="f-12"
                                    :placeholder="$t('addAccident.customerPlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.loadNumberLabel') }}</label>
                                <b-form-input v-model="accidentPayload.load_number" class="f-12"
                                    :placeholder="$t('addAccident.loadNumberPlaceholder')"></b-form-input>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.loadDamagedLabel') }}</label>
                                <b-form-select v-model="accidentPayload.load_damaged" class="f-12" :options="yesNoNullOptions" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4 mb-7rem">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.drugAlcSection') }}</h3>
                    <b-col sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left">
                                <label>{{ $t('addAccident.yesLabel') }}</label>
                                <b-form-checkbox name="check-button" class="ml-0-6rem" v-model="accidentPayload.drug_or_alc"
                                    switch size="lg"></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" v-if="accidentPayload.drug_or_alc">
                        <b-row>
                            <b-col sm="12" class="text-left mt-3">
                                <label for="drug-test-add-datepicker" class="state">{{ $t('addAccident.drugTestLabel') }}</label>
                                <date-picker v-model="accidentPayload.drug_test_date" :formatter="momentFormat"
                                    :range-separator="' - '" @clear="accidentPayload.drug_test_date = ''"
                                    :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom" :teleport="'body'"></date-picker>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.statusLabel') }}</label>
                                <b-form-select v-model="accidentPayload.drug_test_status" class="f-12" :options="drugTestStatusOptions" />
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label for="alc-add-datepicker" class="state">{{ $t('addAccident.alcTestLabel') }}</label>
                                <date-picker v-model="accidentPayload.alc_test_date" :formatter="momentFormat"
                                    :range-separator="' - '" @clear="accidentPayload.alc_test_date = ''"
                                    :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom" :teleport="'body'"></date-picker>
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addAccident.statusLabel') }}</label>
                                <b-form-select v-model="accidentPayload.alc_test_status" class="f-12" :options="drugTestStatusOptions" />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <div class="sidebar-footer position-fixed">
                    <div class="text-right modal-footer border-0 p-0">
                        <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()"
                            variant="secondary">{{ $t('safetyShared.cancel') }}</b-button>
                        <b-button class="mx-0 h-40px px-2 mr-3" @click="onAddNewAccident(true)"
                            variant="outline-primary">{{ $t('safetyShared.saveAndOpen') }}</b-button>
                        <b-button class="mx-0 h-40px w-100px" @click="onAddNewAccident()" variant="primary">{{ $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <DrawingAccident v-if="allowAddAccident" @getAccidentDrawing="getAccidentDrawing($event)"
            :drawingData="accidentPayload.drawing_data" />
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DrawingAccident from "./DrawingAccident.vue"
export default {
    components: { vSelect, DatePicker, DrawingAccident },
    name: "AddAccident",
    props: {
        allowAddAccident: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            "userCompany",
            "allEquipments",
            "allDrivers",
            "allCountries",
            "divisions"
        ]),
        statusOptions() {
            return [
                { value: 'New', text: this.$t('safetyShared.statusNew') },
                { value: 'Open', text: this.$t('safetyShared.statusOpen') },
                { value: 'Closed', text: this.$t('safetyShared.statusClosed') },
                { value: 'Urgent', text: this.$t('safetyShared.statusUrgent') },
            ];
        },
        boolFilterOptions() {
            return [
                { value: '', text: '' },
                { value: true, text: this.$t('safetyShared.yes') },
                { value: false, text: this.$t('safetyShared.no') },
            ];
        },
        yesNoNullOptions() {
            return [
                { value: null, text: '-' },
                { value: false, text: this.$t('safetyShared.no') },
                { value: true, text: this.$t('safetyShared.yes') },
            ];
        },
        hazmatOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Yes', text: this.$t('safetyShared.yes') },
                { value: 'No', text: this.$t('safetyShared.no') },
            ];
        },
        surfaceOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Dry', text: this.$t('addAccident.surfaceDry') },
                { value: 'Wet', text: this.$t('addAccident.surfaceWet') },
            ];
        },
        weatherOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Sunny', text: this.$t('addAccident.weatherSunny') },
                { value: 'Cloudy', text: this.$t('addAccident.weatherCloudy') },
                { value: 'Fog', text: this.$t('addAccident.weatherFog') },
                { value: 'Rain', text: this.$t('addAccident.weatherRain') },
                { value: 'Snow', text: this.$t('addAccident.weatherSnow') },
                { value: 'Wind', text: this.$t('addAccident.weatherWind') },
            ];
        },
        citationIssuesOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'No', text: this.$t('safetyShared.no') },
                { value: 'Yes', text: this.$t('safetyShared.yes') },
                { value: 'Other party', text: this.$t('addAccident.citationOtherParty') },
            ];
        },
        drugTestStatusOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Requested', text: this.$t('addAccident.drugStatusRequested') },
                { value: 'Completed', text: this.$t('addAccident.drugStatusCompleted') },
                { value: 'Results', text: this.$t('addAccident.drugStatusResults') },
            ];
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    data() {
        return {
            errors: {},
            states: [],
            lastRecord: null,
            showRecordField: false,
            claimNumbers: [],
            accidentID: null,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            accidentPayload: {
                address: "",
                alc_test_date: null,
                city: "",
                claim_number: "",
                customer: "",
                drug_test_date: null,
                hazmat_or_gas_spill: "",
                number_of_fatality: null,
                number_of_injury: null,
                number_of_vehicles: null,
                load_number: "",
                officer: "",
                drawing_data: null,
                postal_code: "",
                report_number: "",
                report_state: null,
                state: null,
                surface: "-",
                driver: null,
                record_no: "",
                weather: "-",
                status: "New",
                vehicle: null,
                trailer: null,
                date: null,
                time: null,
                citation_number: "",
                dot_status: null,
                fault_status: null,
                notes: "",
                officer_on_site: false,
                citation_issues: "-",
                ambulance_on_site: false,
                ambulance_name: "",
                ambulance_location: "",
                driver_treated_by_ambulance: null,
                is_fatality: null,
                towing: false,
                towing_name: "",
                towing_location: "",
                vehicle_towed: null,
                loaded_trailer: false,
                load_damaged: null,
                drug_test_status: "-",
                alc_test_status: "-",
                drug_or_alc: false,
                division: null
            },
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            claimOptions: []
        }
    },
    methods: {
        ...mapActions([
            "getFilteredEquipments",
            "getFilteredDrivers",
            "setLoader",
            "addAccident",
            "setNotification",
            "getAllClaims",
            "getAllCountries",
            "getLastRecord"
        ]),

        getAccidentDrawing(payload) {
            if (payload) this.accidentPayload.drawing_data = payload
        },
        async searchClaims(searchText) {
            let options = []
            const url = `sort_field=record_no&search_field=${searchText}&sort_order=desc&page=1&page_size=10`
            const data = await this.getAllClaims(url);
            data.records.forEach((x) => {
                options.push({
                    id: x.record_no.toString(),
                    label: x.record_no.toString(),
                });
            });
            this.claimOptions = this.claimOptions.concat(options)
            this.claimOptions = [...new Map(this.claimOptions.map(item => [item['id'], item])).values()]
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onAddNewAccident(openAccident = false) {
            try {
                const nullKeys = this.checkNullValues({
                    driver: this.accidentPayload.driver,
                    date: this.accidentPayload.date,
                    ...this.showRecordField ? { record_no: this.accidentPayload.record_no } : {},
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    if (!this.showRecordField) delete this.accidentPayload.record_no
                    if (!this.accidentPayload.dot_status) delete this.accidentPayload.dot_status
                    if (!this.accidentPayload.fault_status) delete this.accidentPayload.fault_status
                    if (!this.accidentPayload.driver_treated_by_ambulance) this.accidentPayload.is_fatality = null
                    const record = await this.addAccident({ ...{ ...this.accidentPayload, drawing_data: this.accidentPayload.drawing_data ? JSON.stringify(this.accidentPayload.drawing_data) : null }, company: this.userCompany, claim_number: this.claimNumbers.length ? this.claimNumbers.toString() : '', date: moment(this.accidentPayload.date).format('YYYY-MM-DD'), drug_test_date: this.accidentPayload.drug_test_date ? moment(this.accidentPayload.drug_test_date).format('YYYY-MM-DD') : null, alc_test_date: this.accidentPayload.alc_test_date ? moment(this.accidentPayload.alc_test_date).format('YYYY-MM-DD') : null })
                    await this.setNotification({
                        msg: this.$t('addAccident.added'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false);
                    if (openAccident) this.$emit("accidentAdded", record)
                    else this.$emit("accidentAdded", null)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }

        },
        resetPopup() {
            this.accidentPayload = {
                address: "",
                alc_test_date: null,
                city: "",
                claim_number: "",
                customer: "",
                drawing_data: null,
                drug_test_date: null,
                hazmat_or_gas_spill: "",
                number_of_fatality: null,
                number_of_injury: null,
                number_of_vehicles: null,
                load_number: "",
                officer: "",
                postal_code: "",
                report_number: "",
                report_state: null,
                state: null,
                surface: "-",
                driver: null,
                record_no: "",
                weather: "-",
                status: "New",
                vehicle: null,
                trailer: null,
                date: null,
                time: null,
                citation_number: "",
                dot_status: null,
                fault_status: null,
                notes: "",
                officer_on_site: false,
                citation_issues: "-",
                ambulance_on_site: false,
                ambulance_name: "",
                ambulance_location: "",
                driver_treated_by_ambulance: null,
                is_fatality: null,
                towing: false,
                towing_name: "",
                towing_location: "",
                vehicle_towed: null,
                loaded_trailer: false,
                load_damaged: null,
                drug_test_status: "-",
                alc_test_status: "-",
                drug_or_alc: false,
                division: null

            },
                this.errors = {}
            this.driverOptions = [],
                this.vehicleOptions = [],
                this.trailerOptions = [],
                this.claimOptions = []
            this.claimNumbers = []
            this.$emit('close');
        },
        async searchDriver(searchText) {
            if (searchText) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                driverRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.name,
                    });
                });
                this.driverOptions = this.driverOptions.concat(options)
                this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchVehicle(searchText) {
            if (searchText) {
            let options = [];
            const vehicleRecords =  await this.getFilteredEquipments({unit_no:searchText, type:"Vehicle"});
            vehicleRecords.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.unit_no,
                });
            });
            this.vehicleOptions = this.vehicleOptions.concat(options)
            this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
        } 
        },
        async searchTrailer(searchText) {
            if (searchText) {
            let options = [];
            const trailerRecords = await this.getFilteredEquipments({unit_no:searchText, type:"Trailer"});
            trailerRecords.forEach((x) => {
                options.push({
                    id: x.id,
                    label: x.unit_no,
                });
            });
            this.trailerOptions = this.trailerOptions.concat(options)
            this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
        } 
        },
        async getCountries() {
            await this.getAllCountries();
            const countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates(countries[0]);
        },
        getStates(selectedOption) {
            this.states = this.allCountries
                .filter((country) => country.id === selectedOption.id)[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            this.accidentPayload.state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
            this.accidentPayload.report_state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
        }
    },
    watch: {
        async allowAddAccident() {
            if (this.allowAddAccident) {
                this.setLoader(true)
                const lastItemRecord = await this.getLastRecord({
                    company_id: this.userCompany,
                    query: `model_name=safetyaccident`
                })
                if (lastItemRecord) this.lastRecord = lastItemRecord + 1;
                else this.showRecordField = true
                this.setLoader(false)
            }
        },
    },
    async mounted() {
        await this.getCountries()
    },
}
</script>
<style>
.drawing-section {
    border: 1px solid #EEEEEE;
    border-radius: 8px;
    min-height: 300px;
    max-height: 500px;
    margin-right: 15px;
    margin-left: 15px;
    width: 100%;
}

.drawing-section>img {
    border-radius: 8px;
}

.accident-img-edit {
    position: absolute;
    right: 49px;
    top: 15px;
    cursor: pointer;
    z-index: 10;
}
</style>